import { observer } from 'mobx-react';
import React from 'react';

import Section from 'core/components/section';
import BillingDetails from '../billing-details';

function PaymentDetails() {
  return (
    <Section title="Payment Details" type="SubSection">
      <BillingDetails />
    </Section>
  );
}

export default observer(PaymentDetails);
